import { ChangeEventHandler, KeyboardEventHandler } from 'react'

export enum InputTypes {
	NUMBER = 'number',
	TEXT = 'text',
}

export interface CityType {
	formValues: LeadFormTypes
	errors: LeadFormErrorTypes
	handleForm: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleSubmit: () => void
	updateFormData: (formObj: LeadFormTypes) => void
}

export interface RadioInputOptionTypes {
	name: string
	value: string
	id: string
	label: string
}
export interface RadioInputType {
	formValues: LeadFormTypes
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	//@TODO
	options: RadioInputOptionTypes[]
}

export interface StateType {
	formValues: LeadFormTypes
	errors: LeadFormErrorTypes
	handleForm: (e: React.ChangeEvent<HTMLInputElement>) => void
	handleSubmit: () => void
}

export interface LeadFormTypes {
	regionalLanguageProficiency: string
	name: string
	email: string
	dob: string
	pincode: string
	gender: string
	education: string
	city: string
	state: string
}

export interface OTPVerificationType {
	whatsAppChecked: boolean
}
export interface LeadFormErrorTypes {
	name: string | undefined
	email: string | undefined
	dob: string | undefined
	pincode: string | undefined
	gender: string | undefined
	education: string | undefined
	city: string | undefined
	state: string | undefined
}

export interface PhoneVerificationType {
	whatsAppCheck: () => void
	whatsAppChecked: boolean
}
export interface ButtonType {
	children: React.ReactNode
	onBtnClick: React.MouseEventHandler<HTMLButtonElement>
	bgColor?: string
	isEnabled: boolean
	isLoading: boolean
	height?: string
	width?: string
}

export interface FormInputType {
	label: string
	type: string
	name?: string
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onEnterPress?: KeyboardEventHandler<HTMLInputElement>
	errorMessage?: string
	isValid?: boolean
	value: string | number
	showError?: boolean
	pattern?: string
	maxlength?: number
	marginTop?: string
	autofocus?: boolean
	inputmode?: string
}

export interface FormTextareaType {
	label: string
	name?: string
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	onEnterPress?: KeyboardEventHandler<HTMLInputElement>
	errorMessage?: string
	isValid?: boolean
	value: string | number
	showError?: boolean
}

export interface FormRadioType {
	checked?: boolean
	type: string
	name: string
	handleChange: (e: React.ChangeEvent<HTMLInputElement>) => void
	value: string
	errorMessage: string
	isValid: boolean
	showError?: boolean
}

export interface LoginPhoneType {
	name: string
	type: InputTypes.NUMBER
	label: string
	value: number | string
	changeHandler: ChangeEventHandler<HTMLInputElement>
	onEnterPress: (e: React.KeyboardEvent<HTMLDivElement>) => void
}

export interface TimerType {
	seconds: number
	checkTimer: () => void
}

export interface WrapperButtonType {
	buttonClickHandler: () => void
	isEnabled: boolean
	btnText: string | React.ReactNode
	isLoading: boolean
	height?: string
	width?: string
}

export interface subHeadingType {
	votingAvailable: boolean
	alreadyParticipated: boolean
	SUB_HEADING: string[]
	CLOSED_SUB_HEADING: string[]
	VOTED_ALREADY_SUB_HEADING: string[]
}

export interface exclusiveType {
	EXCLUSIVE_OFFER: string[]
}

export interface offerBannerType {
	OFFER_BANNER: bannerType[]
	phoneNo: number | string
	votingAvailable?: boolean
	alreadyParticipated?: boolean
	scratch?: boolean
	customStyle?: boolean
}

interface bannerType {
	BANNER_URL: string
	BANNER_IMAGE: string
	ANALYTICS_CTA_NAME: string
}

export interface FooterType {
	onSubmit: () => void
	voteSelected: boolean
	isLoading: boolean
}

export interface CountDownTypes {
	seconds: number
	size: number
	strokeColor: string
	strokeBgColor: string
	strokeWidth: number
	textColor: string
	style: string
	timerStatus: boolean
	handleTimerStatus: () => void
}

export interface OptionTypes {
	correctOption: boolean
	option: string
	alternateOptionText: string
	optionId: string
}
